import React, { useState } from 'react'
import Chart from 'react-apexcharts'
import ApexCharts from 'apexcharts'
import { IDadosGraficosPesquisaModel } from '../helpers/AnaliseResultadoHelper'

type Props = {
  dadosGraficosPesquisa: IDadosGraficosPesquisaModel | undefined
  setStatusDeAlcance: React.Dispatch<React.SetStateAction<number>>
  setStatusDeAlcanceColor: React.Dispatch<React.SetStateAction<string>>
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>
}

const GraficoAlcancePesquisa = ({
  dadosGraficosPesquisa,
  setStatusDeAlcance,
  setStatusDeAlcanceColor,
  setShowModal
}: Props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const options = {
    chart: {
      id: 'grafico-alcance-pesquisa',
      events: {
        click: function (
          event: React.ChangeEvent<HTMLInputElement>,
          chartContext: any,
          config: any
        ) {
          const valor = event.target.attributes.getNamedItem('j')?.value
          if (valor !== undefined) {
            setStatusDeAlcance(parseInt(valor) + 1)
            setStatusDeAlcanceColor(
              dadosGraficosPesquisa?.GraficoAlcancePesquisa.Colors[parseInt(valor)] ?? '#FFFFFF'
            )
            setShowModal(true)
          }
        }
      }
    },
    labels: dadosGraficosPesquisa?.GraficoAlcancePesquisa.Labels ?? [],
    colors: dadosGraficosPesquisa?.GraficoAlcancePesquisa.Colors ?? [],
    series: dadosGraficosPesquisa?.GraficoAlcancePesquisa.Series ?? [],
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: '0%'
        }
      }
    }
  }

  const downloadChart = (format: 'png' | 'jpeg') => {
    ApexCharts.exec('grafico-alcance-pesquisa', 'dataURI')
      .then((res: { imgURI: string }) => {
        const link = document.createElement('a')
        link.href = res.imgURI
        link.download = `grafico_alcance_pesquisa.${format}`
        link.click()
      })
      .catch((e: unknown) => {
        console.error('Erro ao gerar imagem:', e)
      })
  }

  return (
    <div className={`card mb-6 ${dadosGraficosPesquisa ? '' : 'd-none'}`}>
      <div className='card-header'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Alcance da pesquisa</h3>
        </div>
        {/* Botão ☰ no canto do card-header */}
        <div className='card-toolbar'>
          <div className='dropdown'>
            <button
              className='btn btn-light btn-sm dropdown-toggle'
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              ☰
            </button>
            <div
              className={`dropdown-menu dropdown-menu-end ${dropdownOpen ? 'show' : ''}`}
              style={{ minWidth: '160px' }}
            >
              <button className='dropdown-item' onClick={() => downloadChart('png')}>
                Baixar PNG
              </button>
              <button className='dropdown-item' onClick={() => downloadChart('jpeg')}>
                Baixar JPEG
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className='card-body py-5'>
        <div className='row justify-content-center my-4'>
          <div className='col-lg-6'>
            <Chart options={options} series={options.series} type='donut' height='400px' />
          </div>
        </div>
      </div>
    </div>
  )
}

export { GraficoAlcancePesquisa }
